import React, { useRef, useState } from 'react';
import { Button } from 'primereact/button';

import SignatureCanvas from 'react-signature-canvas';

import i18n from '../../i18n';

export default function SignaturePad({ onSaveImage, onBack }) {
    const sigCanvas = useRef(null);
    const [canvasSize, setCanvasSize] = React.useState({ width: 800, height: 400 });

    // Prilagodi canvas veličinu na dostupan prostor bez horizontal scrollinga
    React.useEffect(() => {
        const updateCanvasSize = () => {
            const container = sigCanvas.current?.parentElement;
            if (container) {
                // Koristi dostupnu širinu kontejnera ili viewport
                const availableWidth = container.offsetWidth || (window.innerWidth - 40);
                const width = Math.min(availableWidth - 20, 1000);
                const height = Math.min(window.innerHeight - 200, 600);
                setCanvasSize({ width: Math.max(width, 300), height: Math.max(height, 200) });
            }
        };

        updateCanvasSize();
        window.addEventListener('resize', updateCanvasSize);
        // Čekaj da se DOM render-uje pa onda izračunaj veličinu
        setTimeout(updateCanvasSize, 100);
        return () => window.removeEventListener('resize', updateCanvasSize);
    }, []);

    // Čišćenje potpisa
    const clear = () => {
        sigCanvas.current.clear();
    };

    // Pretvaranje Base64 u File
    const dataURLtoFile = (dataURL, filename) => {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    };

    // Snimanje i slanje Laravelu
    const saveAndSend = async () => {
        if (!sigCanvas.current || typeof sigCanvas.current.getTrimmedCanvas !== 'function') {
            alert('SignaturePad is not ready!');
            return;
        }
        const dataURL = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png');

        const file = dataURLtoFile(dataURL, 'signature.png');

        const formData = new FormData();
        formData.append('signature', file);

        try {
            onSaveImage(formData);
        } catch (error) {
            console.error('Greška prilikom slanja', error);
        }
    };

    // const back = () => {
    //     if (onBack) {
    //         onBack();
    //     }
    // };

    // function trim() {
    //     setTrimmedDataURL(sigCanvas.current.getTrimmedCanvas().toDataURL('image/png'));
    // }

    return (
        <div className="w-full h-full flex flex-column" style={{ padding: 0, margin: 0 }}>
            <div className="flex-1 flex justify-content-center align-items-center" style={{ padding: '10px', backgroundColor: '#f5f5f5' }}>
                <SignatureCanvas
                    ref={sigCanvas}
                    penColor="black"
                    backgroundColor="white"
                    canvasProps={{
                        width: canvasSize.width,
                        height: canvasSize.height,
                        className: 'bg-white border-1 border-300',
                        style: {
                            border: '1px solid #ddd',
                            cursor: 'crosshair',
                            touchAction: 'none',
                            boxSizing: 'border-box'
                        }
                    }}
                />
            </div>

            <div className="flex justify-content-between p-3" style={{ gap: '10px' }}>
                <Button onClick={saveAndSend} label={i18n.t('save')} />
                {/* <Button outlined onClick={back} label={i18n.t('back')} /> */}
                <Button onClick={clear} label={i18n.t('clear')} />

                {/* <Button onClick={trim} label="Trim" /> */}
            </div>
            {/* {trimmedDataURL ? <img className={'w-4'} alt="signature" src={trimmedDataURL} /> : null} */}
        </div>
    );
}
